export default __webpack_public_path__ + "static/media/GOLDEN-TICKET-POPUP.5ab28f5d.png";